import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// Visible but locked field: inputs inside are disabled and hovering shows "Read only"
export const ReadOnly = ({ children, className = "", testId, locked = true }) => (!locked ? <div className={className} data-testid={testId}>{children}</div> : (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={`cursor-not-allowed ${className}`} data-testid={testId}>
          <fieldset disabled className="pointer-events-none opacity-70">{children}</fieldset>
        </div>
      </TooltipTrigger>
      <TooltipContent>Read only</TooltipContent>
    </Tooltip>
  </TooltipProvider>
));
